import React from "react";

const InfoPage = () => {
  return (
    <div className="outer-container">
      {/* Sección de los carros (sin transparencia) */}
      <div className="cars-section">
        {/* Aquí podrías tener una imagen de fondo o un carrusel de carros */}
        {/* Ejemplo de imagen fija */}
        <img
          src="https://via.placeholder.com/1200x400?text=Carros+Aquí"
          alt="Carros"
        />
      </div>

      {/* Sección con tu tarjeta y más transparencia */}
      <div className="info-page">
        <div className="info-container">
          <h2>Heritage Car Airport - Luxury Transportation</h2>
          <p>
            Experience unparalleled luxury and comfort with Heritage Car Airport, your trusted transportation service for local and long-distance travel across Westchester County and beyond. We are committed to providing first-class service with a touch of elegance, ensuring every journey is seamless and memorable.
          </p>
          <h3>Service Areas</h3>
          <ul>
            <li>Northern and Southern Westchester</li>
            <li>Dutchess County</li>
            <li>Orange County</li>
            <li>Putnam County</li>
            <li>Rockland County</li>
            <li>New York City</li>
            <li>Local and long-distance destinations</li>
          </ul>
          <h3>Premium Airport Transfers</h3>
          <p>We provide reliable and punctual transfers to major airports, including:</p>
          <ul>
            <li>John F. Kennedy International Airport (JFK)</li>
            <li>Newark Liberty International Airport (EWR)</li>
            <li>LaGuardia Airport (LGA)</li>
            <li>Westchester County Airport (HPN)</li>
            <li>Stewart International Airport</li>
          </ul>
          <h3>Contact Us</h3>
          <p>
            <strong>Phone:</strong>{" "}
            <a href="tel:+19142762961" className="btn">
              (914) 276-2961
            </a>{" "}
            |{" "}
            <a href="tel:+18452258161" className="btn">
              (845) 225-8161
            </a>
          </p>
          <p>
            <strong>Email:</strong>{" "}
            <a href="mailto:heritagecarairport@gmail.com" className="btn">
              heritagecarairport@gmail.com
            </a>
          </p>
          <p>Available 24/7 for all your transportation needs.</p>
        </div>

        {/* Booking Form con capa blanca arriba (si lo deseas) */}
        <div className="booking-modal">
          <div className="booking-outer">
            <iframe
              src="https://bookridesonline.com/book/?dbaid=27Tezv2FIvv7%2fytBuYKNdA%3d%3d"
              title="Booking Form"
            ></iframe>
            <div className="white-overlay"></div>
          </div>
        </div>
      </div>

      <style>{`
        /* Contenedor principal que agrupa todo */
        .outer-container {
          /* Podrías usar un min-height si lo deseas */
          min-height: 100vh;
          width: 100%;
          margin: 0 auto;
          padding: 0;
          box-sizing: border-box;
        }

        /* Sección donde están los carros, sin transparencia */
        .cars-section {
          width: 100%;
          /* Ajusta la altura según tu diseño */
        }
        .cars-section img {
          width: 100%;
          display: block;
        }

        /* TARJETA con más transparencia */
        .info-page {
          font-family: "Poppins", sans-serif;
          color: #333;
          border-radius: 12px;
          box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.2);
          text-align: center;

          /* Mantenemos tus márgenes originales */
          margin-top: 600px;
          margin-bottom: 100px;
          max-width: 1000px;
          margin-left: auto;
          margin-right: auto;
          position: relative;

          /* Fondo más transparente (por ejemplo 0.6) */
          background: rgba(255, 255, 255, 0.6);
          padding: 80px;
        }

        /* CONTENIDO DE TEXTO */
        .info-container h2 {
          font-size: 2.5rem;
          color: #0d2b3e;
          margin-bottom: 20px;
        }
        .info-container h3 {
          font-size: 1.8rem;
          margin-top: 30px;
          color: #1a3d5d;
        }
        .info-container p,
        .info-container ul {
          font-size: 1.2rem;
          line-height: 1.8;
          margin-bottom: 20px;
          text-align: left;
        }

        /* FORMULARIO */
        .booking-modal {
          margin-top: 40px;
          padding: 20px;
          background: rgba(255, 255, 255, 0.85); 
          border-radius: 12px;
          box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.2);
          text-align: center;
        }
        .booking-outer {
          position: relative;
          width: 100%;
          height: 700px;
          overflow: hidden;
        }
        .booking-outer iframe {
          width: 100%;
          height: 700px;
          border: none;
          border-radius: 12px;
          background: #fff;
          box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
        }
        .white-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100px; /* Ajusta para tapar más/menos */
          background: #fff;
          z-index: 2;
        }

        /* BOTONES (teléfono, email) */
        .btn {
          color: #1a3d5d;
          background: #e6f2f7;
          padding: 6px 12px;
          border-radius: 8px;
          font-weight: bold;
          text-decoration: none;
          transition: background 0.3s ease;
        }
        .btn:hover {
          background: #d0e9f3;
        }
      `}</style>
    </div>
  );
};

export default InfoPage;
